import { useEffect, useRef, useState } from "react";
import { Row } from "@/utils/bootstrap";
interface Props {
  count: number;
  setCode: (code: string) => void;
  danger: boolean;
  clear: boolean;
  setClear: (clear: boolean) => void;
}
const InputArray: React.FC<Props> = ({
  count,
  setCode,
  clear,
  setClear,
  danger,
}) => {
  const empty = Array(count)
    .fill(0)
    .reduce((acc, _, i) => ({ ...acc, [i]: "" }), {});

  const [values, setValues] = useState(empty);
  const ref = useRef<any[]>([]);

  const handlePaste = (code: string) => {
    const codeArr = code.substring(0, count).padEnd(count, " ").split("");
    setValues(codeArr.reduce((acc, val, i) => ({ ...acc, [i]: val }), {}));
    setCode(codeArr.join("").trim());
  };

  const handleInputChange = (i: number, value: string) => {
    const fVal = values[i];
    const char = value.replace(fVal, "");
    if (char && !/^\d+$/g.test(char)) return;
    const currentValues = { ...values, [i]: char };
    setValues(currentValues);
    char !== "" && ref.current[i + 1]?.focus();
    setCode(Object.values(currentValues).join(""));
  };

  const handleKeyDown = (key: string, i: number) => {
    switch (key) {
      case "Backspace":
        if (!values[i]) ref.current[i - 1]?.focus();
        else {
          const newValues = { ...values, [i]: "" };
          setValues(newValues);
          setCode(Object.values(newValues).join(""));
        }
        break;
      case "ArrowLeft":
        ref.current[i - 1]?.focus();
        break;
      case "ArrowRight":
        ref.current[i + 1]?.focus();
        break;
    }
  };

  useEffect(() => {
    if (!clear) return;
    setValues(empty);
    ref.current[0]?.focus();
    setCode("");
    setClear(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clear]);

  return (
    <Row className="justify-content-center auth-code" dir="ltr">
      {Array(count)
        .fill("")
        .map((_, i) => (
          <input
            ref={(el: any) => (ref.current[i] = el)}
            autoComplete="new-password"
            autoFocus={i === 0}
            key={i}
            onKeyDown={(e) => handleKeyDown(e.key, i)}
            className={`auth-code-input ${danger ? "danger" : ""}`}
            value={values[i]}
            type="tel"
            onChange={(e) => handleInputChange(i, e.target.value)}
            onPaste={(e) => {
              e.preventDefault();
              handlePaste(e.clipboardData.getData("text"));
            }}
          />
        ))}
    </Row>
  );
};

export default InputArray;
